export const TRANSACTION_DETAILS_ATTRIBUTES_CONSTANT = {
  transaction_status: {
    type: 'select',
    key: 'transaction_status',
    placeholder: 'Status',
  },
  amount_paid: {
    type: 'text',
    key: 'amount_paid',
    label: 'How much paid',
  },
  reason: {
    type: 'textarea',
    key: 'reason',
    label: 'Reason',
  },
  payout_status: {
    type: 'select',
    key: 'payout_status',
    placeholder: 'Status',
  },
} as const;

export const ONLINE_TRANSACTION_STATUS = [
  { name: 'Paid', value: 'Paid' },
  { name: 'Reject', value: 'Reject' },
];

export const OFFLINE_TRANSACTION_STATUS = [
  { name: 'Paid', value: 'Paid' },
  { name: 'Partial Payment', value: 'Partial Payment' },
  { name: 'Reject', value: 'Reject' },
];

/**
 * Pay-out status updates are offered for this partner only.
 *
 * Matched by name rather than id: the partner's own build is recognised from
 * environment.partnerName, and the platform-admin build resolves the id from
 * the partner dropdown, so no numeric id has to be hardcoded here.
 */
export const PAYOUT_STATUS_PARTNER = 'Yarksh';

export const PAYOUT_STATUS_DEFAULT = 'Pending';

export const PAYOUT_STATUS = [
  { name: 'Pending', value: 'Pending' },
  { name: 'Transferred', value: 'Transferred' },
  { name: 'Cancelled', value: 'Cancelled' },
];
